var map = {
	"./Overlijdensberichten placeholder 1.jpg": 54830,
	"./Overlijdensberichten placeholder 2.jpg": 10969,
	"./Overlijdensberichten placeholder 3.jpg": 13596,
	"./Overlijdensberichten placeholder 4.jpg": 21031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40352;